import { isFulfilled } from '@reduxjs/toolkit'
import { ICommitmentEditorItem } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import {
  IRequestAcknowledgementParameters,
  requestAcknowledgement,
} from 'legacy/lut/features/partner360/commitment'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'
import { useCallback } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { ModalDialog } from 'core-components/library/modalDialog'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { useMeasureController } from 'core/analytics/useMeasureController'

import WidgetPartnerContacts from '../../../../partnerContacts/PartnerContacts'
import { AcknowledgmentAction } from '../../enums/AckonwledgmentAction'

interface IProps {
  show: boolean
  partnerId: string
  onClose: () => void
  setIsRefuseCurrentItem: (value: boolean) => void
  onApplyDone?: (res: ICommitmentData[]) => void
  action: AcknowledgmentAction
  ackItem?: ICommitmentEditorItem
  ackPartialInfo?: IObjectAny
  checkContactIsUnique: (email: string) => boolean
}

export const PartnerChangeDialog = ({
  partnerId,
  show,
  setIsRefuseCurrentItem,
  onApplyDone,
  onClose,
  action,
  ackItem,
  ackPartialInfo,
  checkContactIsUnique,
}: IProps) => {
  const dispatch = useAppDispatch()

  const { metrics: partnerContactsMetrics } = useMeasureController(
    'ModalDialogWidgetPartnerContacts'
  )

  const callAcknowledgmentAction = useCallback(
    (parameters: IRequestAcknowledgementParameters) => {
      if (
        (parameters.actionData.Action === AcknowledgmentAction.Change ||
          parameters.actionData.Action === AcknowledgmentAction.Add) &&
        parameters.actionData.Email &&
        !checkContactIsUnique(parameters.actionData.Email)
      ) {
        return
      }
      return dispatch(requestAcknowledgement(parameters))
    },
    [checkContactIsUnique, dispatch]
  )

  return (
    <ModalDialog
      show={show}
      size={'lg'}
      content={() => (
        <WidgetPartnerContacts
          flexWidth={FlexDirectionBreak.p1012}
          metrics={partnerContactsMetrics}
          widgetParams={{}}
          pid={partnerId}
          onSelectProfile={async (item: IForm) => {
            onClose()
            if (ackItem) {
              const reduxAction = await callAcknowledgmentAction({
                partnerId: ackItem.PartnerId,
                fYear: ackItem.FYear,
                programType: ackItem.ProgramType,
                entryId: ackItem.EntryId,
                actionData: {
                  Action: action,
                  Email: item.get('Email'),
                  FirstName: item.get('FirstName'),
                  LastName: item.get('LastName'),
                  ContactId: item.get('ContactID'),
                  CommitmentType: ackItem.CommitmentType,
                },
              })
              if (onApplyDone) {
                if (isFulfilled(reduxAction)) {
                  await onApplyDone(reduxAction.payload)
                }
              }
            } else if (ackPartialInfo) {
              const reduxAction = await callAcknowledgmentAction({
                partnerId: ackPartialInfo.PartnerId,
                fYear: ackPartialInfo.FYear,
                programType: ackPartialInfo.ProgramType,
                entryId: null,
                actionData: {
                  Action: action,
                  Email: item.get('Email'),
                  FirstName: item.get('FirstName'),
                  LastName: item.get('LastName'),
                  ContactId: item.get('ContactID'),
                  CommitmentType: ackPartialInfo.CommitmentType,
                },
              })
              if (onApplyDone) {
                if (isFulfilled(reduxAction)) {
                  await onApplyDone(reduxAction.payload)
                }
              }
            }
          }}
        />
      )}
      onClose={() => {
        onClose()
        setIsRefuseCurrentItem(false)
      }}
    />
  )
}
